import { TypedDocumentNode, gql } from '@apollo/client';

import { isType } from '@sorare/core/src/gql';

import { RewardsFlow } from './RewardsFlow';
import { LastFixtureStoryReworked_story } from './__generated__/index.graphql';
import { useDisplayFixtureStory } from './useDisplayFixtureStory';

type LastFixtureStoryProps = {
  story: Nullable<LastFixtureStoryReworked_story>;
};
export const LastFixtureStory = ({ story }: LastFixtureStoryProps) => {
  const displayFixtureStory = useDisplayFixtureStory(story);

  const { id, readable: so5Fixture } = story || {};
  if (
    !displayFixtureStory ||
    !id ||
    !so5Fixture ||
    !isType(so5Fixture, 'So5Fixture')
  ) {
    return null;
  }

  return (
    <RewardsFlow
      storyId={id}
      so5Fixture={so5Fixture}
      so5Rewards={so5Fixture.mySo5Rewards}
    />
  );
};

LastFixtureStory.fragments = {
  story: gql`
    fragment LastFixtureStoryReworked_story on Story {
      id
      aasmState
      readable {
        ... on FootballRivalsChallenge {
          id
        }
        ... on So5Fixture {
          slug
          mySo5Rewards {
            slug
            ...RewardsFlow_so5Reward
          }
        }
        ...RewardsFlow_so5Fixture
      }
      ...useDisplayFixtureStory_story
    }
    ${RewardsFlow.fragments.so5Reward}
    ${RewardsFlow.fragments.so5Fixture}
    ${useDisplayFixtureStory.fragments.story}
  ` as TypedDocumentNode<LastFixtureStoryReworked_story>,
};
